/* eslint-disable react/no-did-mount-set-state */
import { COUNTRY_CODE_DE, COUNTRY_CODE_ES, COUNTRY_CODE_NL, COUNTRY_CODE_PT } from 'commonsConstants/countryCodes';

import {
    COURIER as COURIER_FLAG,
    IBANTRANSFER as IBANTRANSFER_FLAG,
    NORMALTRANSFER as NORMALTRANSFER_FLAG,
    PHYSICALIDEN as PHYSICALIDEN_FLAG,
    ROBO_IBAN,
    ROBO_TRANSFER,
    ROBO_VIDEOCALL,
    ROBO_VIDEOS,
    ROBO_VIDEOSELFIE,
    TC_IBAN as TC_IBAN_FLAG,
    TC_VIDEOCALL as TC_VIDEOCALL_FLAG,
    TC_VIDEOS as TC_VIDEOS_FLAG,
    TC_VIDEOSELFIE as TC_VIDEOSELFIE_FLAG,
    VIDEOCALL as VIDEOCALL_FLAG,
    VIDEOCALLS_IN_1_BOX as VIDEOS_WITH_TABS_FLAG,
    VIDEOSELFIE as VIDEOSELFIE_FLAG,
} from 'constants/featureFlagging';

import {
    COURIER,
    IBAN,
    IBAN_INVESTMENT_TYPES,
    IDENTITY_METHODS_BY_COUNTRY,
    IDENTITY_METHODS_TAG_BY_COUNTRY,
    TRANSFER_CERTIFICATE,
    TRANSFER_INVESTMENT_TYPES,
    VIDEO_CALL,
    VIDEO_SELFIE,
} from 'constants/identityMethod';

import { CREDIT_CARD, ROBO, TRADITIONAL } from 'constants/userProfile';
import React, { Component } from 'react';
import { connect } from 'react-redux';

function withIdentifyMethodParser(WrappedComponent) {
    class BaseWithIdentifyMethod extends Component {
        state = {
            identifyMethodsByCountry: {
                [COUNTRY_CODE_ES]: [],
                [COUNTRY_CODE_NL]: [],
                [COUNTRY_CODE_PT]: [],
                [COUNTRY_CODE_DE]: [],
            },
            tagByCountry: IDENTITY_METHODS_TAG_BY_COUNTRY,
            investmentType: '',
            addedFlags: false,
        };

        UNSAFE_componentWillMount = () => this.createIdentityMethodBoxesOrderByCountry();

        getIdentifyMethodsByInvestmentType = (investmentType, identifyMethodsByCountry) => {
            const methodsByInvestmentTypeAndCountry = identifyMethodsByCountry[investmentType];

            return methodsByInvestmentTypeAndCountry
                ? methodsByInvestmentTypeAndCountry
                : identifyMethodsByCountry[TRADITIONAL];
        };

        createIdentityMethodBoxesOrderByCountry = () => {
            const { investmentType } = this.props.userProfile;
            const { addedFlags } = this.state;

            !addedFlags &&
                this.setState({
                    identifyMethodsByCountry: {
                        [COUNTRY_CODE_ES]: [
                            ...this.getIdentifyMethodsByInvestmentType(
                                investmentType,
                                IDENTITY_METHODS_BY_COUNTRY[COUNTRY_CODE_ES]
                            ),
                        ],
                        [COUNTRY_CODE_NL]: [
                            ...this.getIdentifyMethodsByInvestmentType(
                                investmentType,
                                IDENTITY_METHODS_BY_COUNTRY[COUNTRY_CODE_NL]
                            ),
                        ],
                        [COUNTRY_CODE_PT]: [
                            ...this.getIdentifyMethodsByInvestmentType(
                                investmentType,
                                IDENTITY_METHODS_BY_COUNTRY[COUNTRY_CODE_PT]
                            ),
                        ],
                        [COUNTRY_CODE_DE]: [
                            ...this.getIdentifyMethodsByInvestmentType(
                                investmentType,
                                IDENTITY_METHODS_BY_COUNTRY[COUNTRY_CODE_DE]
                            ),
                        ],
                    },
                    investmentType,
                    addedFlags: true,
                });
        };

        validateActiveIdentityMethodFlagsByInvestmentType = () => {
            const {
                flags,
                userProfile: { investmentType },
            } = this.props;

            let mappedIdentifyMethods = [];

            const creditCardVideosActive = flags?.get(TC_VIDEOS_FLAG);
            const creditCardIbanActive = flags?.get(TC_IBAN_FLAG);
            const creditCardVideoCallActive = flags?.get(TC_VIDEOCALL_FLAG);
            const creditCardVideoSelfieActive = flags?.get(TC_VIDEOSELFIE_FLAG);

            const roboVideosActive = flags?.get(ROBO_VIDEOS);
            const roboIbanActive = flags?.get(ROBO_IBAN);
            const roboVideoCallActive = flags?.get(ROBO_VIDEOCALL);
            const roboVideoSelfieActive = flags?.get(ROBO_VIDEOSELFIE);
            const roboTransferActive = flags?.get(ROBO_TRANSFER);

            const defaultVideosActive = flags?.get(VIDEOS_WITH_TABS_FLAG);
            const defaultIbanActive = flags?.get(IBANTRANSFER_FLAG);
            const defaultVideoCallActive = flags?.get(VIDEOCALL_FLAG);
            const defaultVideoSelfieActive = flags?.get(VIDEOSELFIE_FLAG);
            const defaultTransferActive = flags?.get(NORMALTRANSFER_FLAG);

            switch (investmentType) {
                case CREDIT_CARD:
                    mappedIdentifyMethods = [
                        ...(creditCardVideosActive
                            ? [TC_VIDEOS_FLAG]
                            : [
                                  ...(creditCardVideoSelfieActive ? [TC_VIDEOSELFIE_FLAG] : []),
                                  ...(creditCardVideoCallActive ? [TC_VIDEOCALL_FLAG] : []),
                              ]),
                    ];

                    mappedIdentifyMethods = [...mappedIdentifyMethods, ...(creditCardIbanActive ? [TC_IBAN_FLAG] : [])];
                    break;
                case ROBO:
                    mappedIdentifyMethods = [
                        ...(roboVideosActive
                            ? [ROBO_VIDEOS]
                            : [
                                  ...(roboVideoSelfieActive ? [ROBO_VIDEOSELFIE] : []),
                                  ...(roboVideoCallActive ? [ROBO_VIDEOCALL] : []),
                              ]),
                    ];

                    mappedIdentifyMethods = [
                        ...mappedIdentifyMethods,
                        ...(roboTransferActive ? [ROBO_TRANSFER] : []),
                        ...(roboIbanActive ? [ROBO_IBAN] : []),
                    ];
                    break;

                default:
                    mappedIdentifyMethods = [
                        ...(defaultVideosActive
                            ? [VIDEOS_WITH_TABS_FLAG]
                            : [
                                  ...(defaultVideoSelfieActive ? [VIDEO_SELFIE] : []),
                                  ...(defaultVideoCallActive ? [VIDEO_CALL] : []),
                              ]),
                    ];

                    mappedIdentifyMethods = [
                        ...mappedIdentifyMethods,
                        ...(defaultIbanActive ? [IBAN] : []),
                        ...(defaultTransferActive ? [TRANSFER_CERTIFICATE] : []),
                    ];
                    break;
            }

            return mappedIdentifyMethods;
        };

        checkActiveIdentificationMethodFlags = () => {
            const { flags } = this.props;
            const { identifyMethodsByCountry } = this.state;

            const mappedIdentifyMethods = [
                ...this.validateActiveIdentityMethodFlagsByInvestmentType(),
                ...(flags?.get(COURIER_FLAG) || flags?.get(PHYSICALIDEN_FLAG) ? [COURIER] : []),
            ];

            return identifyMethodsByCountry[__ORIGIN_COUNTRY__].filter(method =>
                mappedIdentifyMethods.filter(Boolean).includes(method)
            );
        };

        checkIfIbanIsActive = () => {
            const { investmentType } = this.props.userProfile;
            const identificationMethods = this.checkActiveIdentificationMethodFlags();

            return (
                identificationMethods.includes(IBAN_INVESTMENT_TYPES[investmentType]) ||
                identificationMethods.includes(TRANSFER_INVESTMENT_TYPES[investmentType])
            );
        };

        render = () => {
            return (
                <WrappedComponent
                    {...this.props}
                    {...this.state}
                    identificationByCountry={this.checkActiveIdentificationMethodFlags}
                    isIbanActive={this.checkIfIbanIsActive()}
                />
            );
        };
    }

    return connect(state => ({
        flags: state.featureFlagging?.get('data'),
        userProfile: state.userProfile,
    }))(BaseWithIdentifyMethod);
}

export default withIdentifyMethodParser;
